import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Renders AI markdown output as clean, professionally formatted text
 * (real headings, bold, lists) — no raw **, ##, * symbols on screen.
 */
export const Markdown = ({ children, className = "" }) => (
  <div className={`md-body text-sm leading-relaxed ${className}`} data-testid="markdown-body">
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        h1: ({ node, ...p }) => <h3 className="font-serif text-lg text-ink mt-4 mb-2 first:mt-0" {...p} />,
        h2: ({ node, ...p }) => <h3 className="font-serif text-lg text-ink mt-4 mb-2 first:mt-0" {...p} />,
        h3: ({ node, ...p }) => <h4 className="font-semibold text-ink mt-3 mb-1.5 first:mt-0" {...p} />,
        h4: ({ node, ...p }) => <h4 className="font-semibold text-ink mt-3 mb-1.5 first:mt-0" {...p} />,
        p: ({ node, ...p }) => <p className="mb-3 last:mb-0" {...p} />,
        strong: ({ node, ...p }) => <strong className="font-semibold text-ink" {...p} />,
        em: ({ node, ...p }) => <em className="italic" {...p} />,
        ul: ({ node, ...p }) => <ul className="list-disc pl-5 mb-3 space-y-1" {...p} />,
        ol: ({ node, ...p }) => <ol className="list-decimal pl-5 mb-3 space-y-1" {...p} />,
        li: ({ node, ...p }) => <li className="pl-1" {...p} />,
        a: ({ node, ...p }) => <a className="text-gold underline underline-offset-2" target="_blank" rel="noreferrer" {...p} />,
        blockquote: ({ node, ...p }) => <blockquote className="border-l-2 border-gold/40 pl-4 italic text-inkmuted my-3" {...p} />,
        code: ({ node, inline, ...p }) =>
          inline
            ? <code className="font-mono text-[12px] bg-surface2 rounded px-1.5 py-0.5" {...p} />
            : <code className="block font-mono text-[12px] bg-canvas/40 rounded-lg p-3 my-3 overflow-x-auto" {...p} />,
        hr: () => <hr className="border-hairline my-4" />,
        table: ({ node, ...p }) => <table className="w-full text-xs my-3 border-collapse" {...p} />,
        th: ({ node, ...p }) => <th className="border border-hairline px-2 py-1 text-left text-ink" {...p} />,
        td: ({ node, ...p }) => <td className="border border-hairline px-2 py-1" {...p} />,
      }}
    >
      {children || ""}
    </ReactMarkdown>
  </div>
);
